import React from 'react';
import { useSelector } from 'react-redux';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { PLAID } from 'apps/auth/constants/UrlConstants';

const PlaidIntro = (props) => {
    const messages = useSelector(({ messages: { pageMessages } }) => pageMessages);
    return (
        <InfoPage
            insideModalComponent={true}
            iconName="plaid"
            iconColor="primary"
            headerText={messages.increase_sub_block}
            primaryButtonCaption={messages.gotIt}
            primaryButtonType="button"
            primaryButtonOnClick={props.onClick}
            buttonRowCaption={messages.learnMoreLink}
            buttonRowHref={PLAID}
            buttonRowType="link"
            buttonRowTarget="_blank"
            buttonRowRel="noreferrer noopener nofollower"
        />
    );
};
export default PlaidIntro;
